import { createSelector } from '@reduxjs/toolkit';

const _getLocale = (state) => state.app.language;

export const getLocale: (state: Record<string, any>) => string = createSelector(
  [_getLocale],
  (locale: string): string => locale,
);
